module.exports = __webpack_public_path__ + "img/certificat1.066f13c1.png";